// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e59845f2","455":"4f40a60c","977":"d20f6cd4"}[chunkId] + ".chunk.js";
};